export const ACTUALIZAR_LIST_GROUP = "ACTUALIZAR_LIST_GROUP";
export const MODIFICAR_GROUP = "MODIFICAR_GROUP";
export const AGREGAR_GROUP = "AGREGAR_GROUP";  
export const ELIMINAR_GROUP = "ELIMINAR_GROUP";